import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Same portalled shell as ErrorPopup (see there for why it is portalled), for
 * things the user should know about that aren't their error — e.g. a data
 * folder deleted by someone else while they were uploading to it.
 */
const WarningPopup = ({ onClose, message, title }) => {
  return ReactDOM.createPortal(
    <div className="popup">
      <div className="popup-content">
        <div className="text-end">
          <button className="bg-transparent border-0" onClick={onClose}><i className="bi bi-x-circle"></i></button>
        </div>
        <div className="text-center mt-2">
          <p className="mb-2 text-warning ev-fs-20"><i className="bi bi-exclamation-triangle"></i></p>
          {title && <p className="ev-fs-13 ev-bold-med mb-1">{title}</p>}
          <p className="ev-fs-12 ev-bold-reg">{message}</p>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default WarningPopup;
